import React from 'react';

import { CanvasAnimatedTile } from 'themes/canvas/components/CanvasAnimatedTile';

import { TImage } from 'types/portfolio';

import s from './CanvasPortfolio.module.css';

interface CanvasPortfolioImageProps {
  caption: string;
  image: TImage;
}

const CanvasPortfolioImage: React.FC<CanvasPortfolioImageProps> = ({
  image: { medium },
  caption,
}) => {
  return (
    <div className={s.item}>
      <CanvasAnimatedTile>
        <div className={s.imageWrapper}>
          <figure className={s.image}>
            <img src={medium} alt={caption}></img>
            <figcaption className={s.fullDescription}>{caption}</figcaption>
          </figure>
        </div>
        <p>{caption}</p>
      </CanvasAnimatedTile>
    </div>
  );
};

export { CanvasPortfolioImage };
